import paintingsConfig from './paintingsConfig';
import photographsConfig from './photographsConfig';

export default [
  paintingsConfig,
  photographsConfig
]